import { render, staticRenderFns } from "./AboutUs_DE.vue?vue&type=template&id=172d4a6b&scoped=true&"
import script from "./AboutUs_DE.vue?vue&type=script&lang=js&"
export * from "./AboutUs_DE.vue?vue&type=script&lang=js&"
import style0 from "./AboutUs_DE.vue?vue&type=style&index=0&id=172d4a6b&prod&lang=css&"
import style1 from "./AboutUs_DE.vue?vue&type=style&index=1&id=172d4a6b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "172d4a6b",
  null
  
)

export default component.exports